import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { i18n } from '../../lang/i18n';
import './BackArrow.scss';

interface Props {
    path?: string
}

export default function BackArrow(props: Props) {
    const navigate = useNavigate();
    function goBack() {
        navigate(-1)
    }
    if (props.path)
        return  <>
            <NavLink to={props.path} className="btn-back link-btn  btn-fixed-lb"> <i className="fa fa-arrow-left" /> {i18n._BTNs.Back}</NavLink>
            <br/>
        </>
    return <>
        <div className="btn-back link-btn  btn-fixed-lb" onClick={goBack}> <i className="fa fa-arrow-left" /> {i18n._BTNs.Back}</div>
        <br/>
    </>;
}
